// extracted by mini-css-extract-plugin
export default {"journey":"styles_journey__4mlRu","container":"styles_container__7iiOd"};